import React from 'react';

import { Box, Heading, Paragraph } from '@zillow/constellation';

import { CONTAINER_SX } from '../../constants/styles';
import { HOME_RECS_FOOTER_HEADING, HOME_RECS_FOOTER_TEXT } from '../../constants/text';
import { useGlobalStoreState } from '../../contexts/GlobalStoreProvider';

const HomeRecsFooter = () => {
    const { isVisualRefreshEnabled } = useGlobalStoreState();

    return (
        <Box
            sx={{
                ...(isVisualRefreshEnabled
                    ? CONTAINER_SX
                    : {
                          margin: '$spacing.md auto',
                          padding: '0 $spacing.md',
                          width: '1200px',
                          maxWidth: '100%',
                      }),
            }}
        >
            <Heading level="6" fontFamily="sansSerif">
                {HOME_RECS_FOOTER_HEADING}
            </Heading>
            <Paragraph fontType="body" fontColor="textMedium">
                {HOME_RECS_FOOTER_TEXT}
            </Paragraph>
        </Box>
    );
};

export default HomeRecsFooter;
